import { convertString } from "../../../common/Utils/commonFunction";

import Translate from "../../../translation/utils/translateFunction";

export const getLeaveRequestColumns = (
  CustomSrCellRender,
  CustomActionCellRender
) => {
  const columns = [
    {
      field: "lineNo",
      headerName: Translate("common:srNoTitle"),
      align: "center",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: CustomSrCellRender,
    },
    {
      field: "name",
      headerName: Translate("leaveRequest:name"),
      flex: 0.35,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "designation",
      headerName: Translate("leaveRequest:role"),
      flex: 0.35,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => convertString(params?.row?.designation),
    },
    {
      field: "createdDate",
      headerName: Translate("leaveRequest:requestedDate"),
      flex: 0.35,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const { requestedDate, formattedTime } = params?.row;

        return (
          <div>
            <div className="text-info">{requestedDate}</div>

            <div className="text-pink">{formattedTime}</div>
          </div>
        );
      },
    },
    {
      field: "date",
      headerName: Translate("reports:appliedFor"),
      flex: 0.4,
      sortable: false,
      disableColumnMenu: true,
      valueGetter: (params) =>
        `${params.row?.startDate} - ${params.row?.endDate}`,
    },
    {
      field: "duration",
      headerName: Translate("leaveRequest:leaveDur"),
      flex: 0.3,
      sortable: false,
      disableColumnMenu: true,
      valueGetter: (params) =>
        params?.row?.duration === "1"
          ? `${params.row?.duration} Day`
          : `${params.row?.duration} Days`,
    },

    {
      field: "leaveStatus",
      headerName: Translate("leaveRequest:status"),
      flex: 0.2,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "action",
      headerName: Translate("common:actionTitle"),
      align: "center",
      headerAlign: "center",
      flex: 0.2,
      sortable: false,
      disableColumnMenu: true,
      renderCell: CustomActionCellRender,
    },
  ];

  return columns;
};
